module.exports = __webpack_public_path__ + "static/media/imageIconGallery.7a1ae4af.svg";